<template>
  <div class="button">
    <button v-bind="$attrs" @click="$emit('click', $event)">
      <slot v-if="!spinner"></slot>
      <div :class="{'loader': spinner}"></div>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'WButton',
    props: {
      spinner: {
        type: Boolean,
        required: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "../../assets/styles/variables";

  .loader {
    border: 4px solid #f3f3f3;
    border-radius: 89%;
    border-top: 4px solid #FFFFFF;
    width: 30px;
    height: 30px;
    margin: 0 auto;
    color: #ffffff;
    -webkit-animation: spin-data-v-f1b986ec 2s linear infinite;
    animation: spin-data-v-f1b986ec 2s linear infinite;
  }
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .button {
    border: none;
    background-color: $secondary-main;
    width: 392px;
    height: 56px;
    box-sizing: border-box;
    padding: 0;
    border-radius: 55px;
    @media(max-width: 996px) {
      width: 100% !important;
    }
    button {
      width: 100%;
      padding: 0 13px;
      height: 100%;
      border-radius: 55px;
      border: none;
      background-color: transparent;
      color: $background-4;
      font-size: 14px;
      font-weight: 500;
      text-transform: uppercase;
      transition: all 0.2s;
      outline: none;
      cursor: pointer;
      font-family: 'Roboto';

      @include shadow-4;

      &:focus {
        @include shadow-3;
      }

      &:disabled {
        opacity: 1;
        background-color: $secondary-main;
        color: rgba(255, 255, 255, 0.5);
      }
      @media(max-width: 996px) {
        padding: 0 9px;
      }
    }
    &.button--gradient button {
      background: $gradient-4;
    }

    &.button--light button {
      background-color: $background-4;
      color: $secondary-main;
    }
  }
  .cancel {
    background: $background-4;
    button {
      color: $secondary-main;
    }
  }
  .disabled {
    button {
      cursor: not-allowed !important;
      box-shadow: none;
    }
  }
</style>
